import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { DxDataGridComponent, DxLookupComponent } from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { firstValueFrom } from 'rxjs';
import { Mansioni } from 'src/app/models/mansioni';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { MansioniService } from 'src/app/shared/services/mansioni.service';
import { ModelliMansioniService } from 'src/app/shared/services/modelli-mansioni.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-modelli-mansioni',
  templateUrl: './modelli-mansioni.component.html',
  imports: [
    DxDataGridComponent,
    DxLookupComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
    DxoLookupComponent,
    DxoExportComponent
  ],
  standalone: true,
})
export class ModelliMansioniComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private mansioniService = inject(MansioniService);
  private tipiArticoliService = inject(TipiArticoliService);
  private modManService = inject(ModelliMansioniService);
  dataSource: any;
  listMansioni: Mansioni[] = [];
  listTipiArticoli: any;
  idMansioneSelezionata: number = 0;

  ngOnInit() {
    this.loadLookups();
    this.loadDataSource();
  }

  loadLookups() {
    this.mansioniService.list().subscribe({
      next: (res) => {
        this.listMansioni = res;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento mansioni', 'warning');
        }
      },
    });

    this.tipiArticoliService.list().subscribe({
      next: (res) => {
        this.listTipiArticoli = res;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento tipi articoli', 'warning');
        }
      },
    });
  }

  onMansioneValueChanged(e: any) {
    this.idMansioneSelezionata = e.value;
    this.loadDataSource();
  }

  onUpdating(e: any) {
    e.newData = Object.assign(e.oldData, e.newData);
  }

  onInitNewRow(e: any) {
    e.data.idMansione = this.idMansioneSelezionata;
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(
          this.modManService.listByMansione(this.idMansioneSelezionata),
        )
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        return firstValueFrom(this.modManService.insert(values)).catch(
          (error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Insert failed';
            }
          },
        );
      },
      remove: (values) => {
        console.log(values);
        return (
          firstValueFrom(this.modManService.remove(values))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => console.log('delete eseguito'))
            .catch((error: HttpErrorResponse) => {
              if (error.status == 500) {
                throw error.error.title;
              } else {
                throw 'Deletion failed';
              }
            })
        );
      },
      update: (key, values) => {
        return firstValueFrom(this.modManService.update(key, values)).catch(
          (error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Update failed';
            }
          },
        );
      },
    });
  }

  getMansioneDisplayExpr(item: Mansioni) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.descrizione;
  }

  onExporting(e: any){
    const mansione = this.listMansioni.find(x => x.id == this.idMansioneSelezionata);
    const nomeFile = 'Modelli_Mansioni' + mansione != undefined ? '_' + mansione?.descrizione : '';
    GridExportExcel(e, 'Modelli Mansioni', nomeFile + '.xlsx');
  }
}
